import firebase from 'firebase/app';
import 'firebase/auth';

export default {
    state: {
        user: null,
        loginError: null,
        loggingIn: false
    },
    mutations: {
        setUser(state, payload) {
            // Payload == Firebase User
            if (payload !== null && payload !== undefined){
                let user = {
                    id: payload.uid,
                    email: payload.email,
                    name: payload.displayName
                }
                state.user = user
            } else {
                state.user = null
            }
        },
        loginError(state, payload) {
            state.loginError = payload
        },
        clearLoginError(state) {
            state.loginError = null
        },
        loggingIn(state, payload) {
            state.loggingIn = payload;
        }
    },
    actions: {
        signIn({commit}, payload) {
            commit('loggingIn', true);
            firebase.auth().signInWithEmailAndPassword(payload.username, payload.password)
            .then((fbUser) => { 
                commit('setUser', fbUser);
                commit('clearLoginError');
                commit('loggingIn', false);
             })
            .catch((error) => { 
                commit('loginError', error)
                console.log(`Error logging in `) ;
                commit('loggingIn', false);
            });
        },
        signOut({commit}, payload) {
            firebase.auth().signOut()
            .then(() => {
                console.log('logged out')
                commit('setUser', null);
            })
            .catch((error) => {})
        }
    },
    getters: {
        user(state) {
            return state.user;
        },
        loginError(state) {
            return state.loginError
        },
        loggingIn(state) {
            return state.loggingIn;
        }
    }
}